// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nuaqHkhuQs1N9VfO20Jo{margin-left:6px}.JZb51BCXDnuJDUNS6x9A{margin-left:13px}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/ui/ConversationHeaderListDropdown/ui/ConversationHeaderListDropdown/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CAEF,sBACE,gBAAA","sourcesContent":[".dropdownContent {\n  margin-left: 6px;\n}\n.dropdownContentMobile {\n  margin-left: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContent": `nuaqHkhuQs1N9VfO20Jo`,
	"dropdownContentMobile": `JZb51BCXDnuJDUNS6x9A`
};
export default ___CSS_LOADER_EXPORT___;
